import { PhoneNumber as ResponsePhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { ValidationRule } from "@/Common/Api/Validation/Dto/Responses/ValidationRule";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

class PhoneNumber {
    public Model: ResponsePhoneNumber;

    constructor(model: ResponsePhoneNumber) {
        this.Model = model;
    }

    public format(format: string = "+{0} ({1}) {2} {3} {4}", formatExtension: string = " Ext.{Ext}"): string {
        return ResponsePhoneNumber.GetFormattedPhoneNumber(0, [this.Model], format, formatExtension);
    }

    public static getLabelFormat(phoneNumber: string): string {
        const s2 = ("" + phoneNumber).replace(/\D/g, "");
        const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        return (!m) ? null : `(${m[1]}) ${m[2]}-${m[3]}`;
    }

    public static GetPhonesByPriority(phones: ResponsePhoneNumber[]): PhoneNumber[] {
        if (phones == null)
            return [];

        let otherType = cacheStore.FindLookupByLookupCode("OTHERCONTACTPOINT", "CONTACTPOINTTYPE");
        let workType = cacheStore.FindLookupByLookupCode("WORK", "CONTACTPOINTTYPE");
        let personalType = cacheStore.FindLookupByLookupCode("PERSONAL", "CONTACTPOINTTYPE");
        let cellType = cacheStore.FindLookupByLookupCode("MOBILE", "PHONETYPE");
        let phoneType = cacheStore.FindLookupByLookupCode("PHONE", "PHONETYPE");
        let pagerType = cacheStore.FindLookupByLookupCode("PAGER", "PHONETYPE");
        let faxType = cacheStore.FindLookupByLookupCode("FAX", "PHONETYPE");

        // remove others not preferred
        let displayablePhones = phones.filter(x => !(x.ContactPointTypeLookupId == otherType.LookupID && !x.IsPreferred));
        displayablePhones = displayablePhones.filter(x => x.Number != "0"); // hack for fuckin interfaces injecting garbage

        // order by contactType/phonetype
        return displayablePhones.map(x => new PhoneNumber(x)).sortByProperty(phone => {
            let p = phone.Model;
            let tmpPriority = p.IsPreferred ? "1" : "2";

            switch (p.ContactPointTypeLookupId) {
                case personalType.LookupID:
                    tmpPriority += "A";
                    break;
                case workType.LookupID:
                    tmpPriority += "B";
                    break;
                default:
                    tmpPriority += "Z";
            }

            switch (p.PhoneTypeLookupId) {
                case cellType.LookupID:
                    tmpPriority += "A";
                    break;
                case phoneType.LookupID:
                    tmpPriority += "B";
                    break;
                case pagerType.LookupID:
                    tmpPriority += "C";
                    break;
                case faxType.LookupID:
                    tmpPriority += "D";
                    break;
                default:
                    tmpPriority += "Z";
            }

            return tmpPriority;
        });
    }
}

class PhoneNumberDeprecated {
    public validationHelper = new ValidationHelper();
    public validationRule: ValidationRule;

    public Extension: string;
    public Number: string;
    public PhoneType: string;
    public Notes: string;
    public NumberType: string;
    public CountryLookupId: string;
    public StateLookupId: string;
    public IsPrefered: boolean;
    public IsValid: boolean = true;

    constructor() {
        this.Extension = "";
        this.Number = "";
        this.PhoneType = ""; // cell or fixe
        this.Notes = "";
        this.NumberType = ""; // personal or work
        this.IsPrefered = false;
        this.validationHelper = new ValidationHelper();
    }

    public FormatNumber(): string {
        // get validation info
        var displayFormatSelector: string = this.validationRule ? this.validationRule.DisplayFormatSelectorPatern : "";
        var displayFormatSubstitution: string = this.validationRule ? this.validationRule.DisplayFormatSubstitution : "";
        var result = this.validationHelper.getFormatedString(this.Number, displayFormatSelector, displayFormatSubstitution);
        return result;
    }

    public static FromResponseModel(response: ResponsePhoneNumber): PhoneNumberDeprecated {
        var number = new PhoneNumberDeprecated();

        number.Extension = response.Extension ?? "";
        number.Notes = response.Notes;
        number.PhoneType = cacheStore.GetLocalizedValueByLookupId(response.PhoneTypeLookupId);
        number.Number = response.Number;
        number.CountryLookupId = response.CountryLookupId;
        number.StateLookupId = response.StateLookupId;
        number.IsPrefered = response.IsPreferred;
        number.validationRule = number.validationHelper.getPhoneNumberValidationRule(number.CountryLookupId, null);

        return number;
    }
}

export { PhoneNumber, PhoneNumberDeprecated };
